import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetonashiktempotravelleer() {



  const cardData =
  {
    keyword: 'Pune to Nashik Tempo Traveller On Rent ',
    heading: 'Sanavi Travels: Pune to Nashik Tempo Traveller On Rent',
    headingDescription: 'Sanavi Travels offers reliable Pune to Nashik Tempo Traveller on Rent, providing safe, comfortable, and hassle-free group travel for families, pilgrims, corporate teams, tourists, and wine-tour groups traveling from Pune to Nashik. Our well-maintained fleet of 9, 12, 13, 17, and 20 seater tempo travellers is ideal for pilgrimage tours, weekend getaways, corporate outings, and sightseeing trips, ensuring spacious seating, air-conditioned comfort, and ample luggage space. With experienced chauffeurs familiar with Pune–Nashik highway routes, flexible one-way and round-trip rental options, transparent pricing, and 24/7 booking support, Sanavi Travels ensures a smooth and timely journey. From doorstep pickup across Pune—including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, and Pune Airport—to convenient drop-off at Nashik destinations such as Trimbakeshwar, Sula Vineyards, Panchavati, and nearby locations, Sanavi Travels provides trusted Pune to Nashik Tempo Traveller rental services for travelers seeking comfort, safety, and reliable intercity transportation.',

    top: 'Top Places to Visit in Nashik with Sanavi Travels',


 "topPlaces": [
  {
    "title": "Trimbakeshwar Temple",
    "description": "Trimbakeshwar Temple is one of the twelve Jyotirlingas of Lord Shiva and the most sacred site in Nashik. Located at the origin of the Godavari River, the temple is built in traditional black stone architecture. It attracts millions of pilgrims, especially during the Kumbh Mela. Trimbakeshwar is the spiritual heart of Nashik, symbolizing devotion, purity, and divine energy."
  },
  {
    "title": "Ramkund",
    "description": "Ramkund is a holy bathing ghat on the banks of the Godavari River, believed to be the place where Lord Rama performed ancestral rituals. Devotees gather here for rituals, prayers, and spiritual ceremonies. The area is surrounded by ancient temples and narrow traditional lanes. Ramkund represents Nashik’s deep mythological and religious roots."
  },
  {
    "title": "Sita Gufa",
    "description": "Sita Gufa is a sacred cave associated with the Ramayana, believed to be the place where Goddess Sita stayed during exile. Inside the cave are idols of Lord Rama, Sita, and Lakshmana, along with sacred footprints. The site holds immense religious significance and spiritual calm. Sita Gufa connects Nashik to India’s epic heritage."
  },
  {
    "title": "Panchavati",
    "description": "Panchavati is an ancient area in Nashik closely linked to the Ramayana, where Lord Rama, Sita, and Lakshmana are believed to have lived. It is home to sacred sites like Ramkund, Sita Gufa, and Kalaram Temple. The area has a vibrant spiritual atmosphere with pilgrims and saints. Panchavati is the cultural and religious soul of Nashik."
  },
  {
    "title": "Kalaram Temple",
    "description": "Kalaram Temple is a prominent shrine dedicated to Lord Rama, built using black stone and known for its impressive architecture. The temple played a significant role in India’s social reform movement led by Dr. B.R. Ambedkar. Its serene ambiance and historical importance attract devotees and history enthusiasts alike. Kalaram Temple stands as a symbol of faith and equality."
  },
  {
    "title": "Sula Vineyards",
    "description": "Sula Vineyards is India’s most famous wine destination, offering scenic vineyard views, wine tasting sessions, and guided tours. Nestled amidst rolling hills and greenery, it provides a relaxing experience for visitors. The annual SulaFest attracts music and wine lovers from across the country. Sula Vineyards showcases Nashik’s modern lifestyle and global appeal."
  },
  {
    "title": "Pandavleni Caves",
    "description": "Pandavleni Caves are ancient rock-cut caves dating back to the 1st century BCE, located on a hilltop overlooking Nashik city. These Buddhist caves feature inscriptions, meditation halls, and water tanks. The site offers panoramic views and a peaceful atmosphere. Pandavleni reflects Nashik’s rich ancient history and architectural heritage."
  },
  {
    "title": "Anjneri Hill",
    "description": "Anjneri Hill is believed to be the birthplace of Lord Hanuman and is a popular trekking and pilgrimage destination. Surrounded by lush greenery, the hill offers scenic trails and breathtaking views. During monsoon, the area becomes especially beautiful. Anjneri Hill blends spirituality, adventure, and natural beauty."
  },
  {
    "title": "Godavari Ghat",
    "description": "Godavari Ghat is a serene riverside area where devotees gather for rituals, prayers, and evening aartis. The ghats are beautifully lit during festivals and religious events. The flowing Godavari River adds calmness to the spiritual setting. Godavari Ghat represents Nashik’s sacred river culture and peaceful ambiance."
  },
  {
    "title": "Coin Museum",
    "description": "The Indian Institute of Research in Numismatic Studies (Coin Museum) houses a vast collection of ancient and medieval coins. It provides valuable insights into India’s economic and historical evolution. The museum is educational and informative, especially for students and history lovers. The Coin Museum adds a unique cultural dimension to Nashik’s attractions."
  }
]
,




 "services": [
    {
      "name": "Pune to Nashik Tempo Traveller On Rent",
      "description": "Pune to Nashik Tempo Traveller On Rent provides comfortable and reliable vehicles for groups traveling between Pune and Nashik. Well-maintained and spacious, these vehicles are ideal for family trips, corporate outings, and group tours. Professional drivers ensure safety and punctuality, while passengers enjoy a smooth journey on highways and city roads. Flexible booking options and transparent pricing make it convenient for travelers planning their trip to Nashik for sightseeing, business, or leisure."
    },
    {
      "name": "Nashik Tempo Traveller Hire from Pune",
      "description": "Nashik Tempo Traveller Hire from Pune offers flexible rental services for short or long trips between Pune and Nashik. Vehicles come equipped with comfortable seating, ample luggage space, and air-conditioning for a pleasant journey. Experienced drivers manage routes efficiently, ensuring timely arrivals and a hassle-free travel experience. Ideal for family vacations, corporate trips, or sightseeing tours, this service combines convenience, reliability, and comfort."
    },
    {
      "name": "AC Tempo Traveller Pune to Nashik",
      "description": "AC Tempo Traveller Pune to Nashik provides air-conditioned vehicles for a cool and comfortable journey. Perfect for long-distance travel, corporate trips, or family vacations, these vehicles offer spacious seating and luggage-friendly interiors. Professional chauffeurs ensure safe driving and optimized routes, allowing passengers to relax and enjoy a smooth, stress-free ride from Pune to Nashik."
    },
    {
      "name": "Luxury Tempo Traveller Nashik Trip",
      "description": "Luxury Tempo Traveller Nashik Trip offers premium, well-appointed vehicles for a stylish and comfortable travel experience. Equipped with reclining seats, entertainment systems, and ample luggage space, these vehicles are ideal for VIP trips, corporate outings, or special family journeys. Professional drivers ensure punctual and safe transfers, making the journey elegant, convenient, and enjoyable."
    },
    {
      "name": "Family Tempo Traveller Nashik",
      "description": "Family Tempo Traveller Nashik ensures safe and comfortable travel for families commuting between Pune and Nashik. Vehicles provide ample seating, luggage space, and child-friendly features for long-distance travel. Experienced drivers follow safe and scenic routes, ensuring a stress-free journey. Perfect for weekend trips, family outings, or sightseeing tours, this service prioritizes comfort, safety, and convenience for all family members."
    },
    {
      "name": "Corporate Tempo Traveller Nashik",
      "description": "Corporate Tempo Traveller Nashik caters to business travelers and office groups commuting between Pune and Nashik. Vehicles are equipped with premium interiors, spacious seating, and amenities for relaxation or work during travel. Professional chauffeurs maintain punctuality and safe driving, making this service ideal for corporate meetings, conferences, or executive trips with comfort and reliability."
    },
    {
      "name": "Wine Tour Tempo Traveller Nashik",
      "description": "Wine Tour Tempo Traveller Nashik is specially designed for wine enthusiasts visiting Nashik’s vineyards. Vehicles are spacious, comfortable, and ideal for group travel, allowing passengers to enjoy wine tours safely and conveniently. Experienced drivers manage routes efficiently, providing a relaxing and enjoyable experience while exploring Nashik’s famous wineries and scenic surroundings."
    },
    {
      "name": "Affordable Tempo Traveller Nashik",
      "description": "Affordable Tempo Traveller Nashik offers budget-friendly travel options for groups without compromising comfort or safety. Well-maintained vehicles, professional drivers, and spacious seating ensure a smooth journey. Perfect for family trips, friends traveling together, or corporate groups seeking economical transport, this service combines affordability with reliability and convenience."
    },
    {
      "name": "Chauffeur Driven Tempo Traveller Nashik",
      "description": "Chauffeur Driven Tempo Traveller Nashik provides professional drivers for hassle-free travel between Pune and Nashik. Passengers can relax while experienced chauffeurs handle routes, traffic, and navigation. Spacious and comfortable vehicles accommodate families, friends, or corporate groups, offering convenience, safety, and peace of mind throughout the journey."
    },
    {
      "name": "Group Travel Tempo Traveller Nashik",
      "description": "Group Travel Tempo Traveller Nashik caters to large groups commuting between Pune and Nashik. Vehicles are spacious, well-maintained, and equipped for long-distance travel, ensuring comfort for all passengers. Professional drivers manage the journey efficiently, guaranteeing timely arrivals and a smooth travel experience. Perfect for corporate groups, school trips, or friends traveling together."
    },
    {
      "name": "Best Tempo Traveller Pune to Nashik",
      "description": "Best Tempo Traveller Pune to Nashik offers top-quality vehicles and professional service for a superior travel experience. Comfortable interiors, skilled drivers, and attention to passenger convenience ensure a smooth journey. Suitable for families, friends, and corporate travelers, this service emphasizes safety, punctuality, and comfort while traveling between Pune and Nashik."
    },
    {
      "name": "Tempo Traveller Rental Pune Nashik",
      "description": "Tempo Traveller Rental Pune Nashik provides reliable and well-maintained vehicles for trips between Pune and Nashik. Ideal for long-distance family vacations, corporate travel, or group tours, these vehicles offer ample seating, luggage space, and air-conditioning. Professional drivers ensure safe and timely travel, making the journey convenient, comfortable, and stress-free."
    },
    {
      "name": "Weekend Trip Tempo Traveller Nashik",
      "description": "Weekend Trip Tempo Traveller Nashik offers vehicles for short getaways from Pune to Nashik. Perfect for sightseeing, family outings, or friends’ trips, these vehicles provide comfort, ample space, and reliable service. Skilled drivers ensure timely pick-ups and drop-offs, making weekend trips convenient, enjoyable, and memorable for all passengers."
    },
    {
      "name": "Pune Nashik Travel Vehicle",
      "description": "Pune Nashik Travel Vehicle provides dependable transport for individuals or groups traveling between Pune and Nashik. Spacious, comfortable, and maintained for safety, these vehicles are ideal for family trips, friends traveling together, or corporate commuters. Professional drivers handle highways and city routes efficiently, ensuring a smooth and pleasant journey."
    },
    {
      "name": "Nashik Darshan Tempo Traveller",
      "description": "Nashik Darshan Tempo Traveller offers convenient vehicles for sightseeing and spiritual trips in Nashik. Perfect for devotees, families, or tourists, these vehicles provide comfortable seating, luggage space, and professional drivers. Passengers enjoy a stress-free journey while visiting Nashik temples, vineyards, and cultural sites with ease and comfort."
    }
  ],
  "tableData": [
    ["Pune to Nashik Tempo Traveller On Rent", "Nashik Tempo Traveller Hire from Pune"],
    ["AC Tempo Traveller Pune to Nashik", "Luxury Tempo Traveller Nashik Trip"],
    ["Family Tempo Traveller Nashik", "Corporate Tempo Traveller Nashik"],
    ["Wine Tour Tempo Traveller Nashik", "Affordable Tempo Traveller Nashik"],
    ["Chauffeur Driven Tempo Traveller Nashik", "Group Travel Tempo Traveller Nashik"],
    ["Best Tempo Traveller Pune to Nashik", "Tempo Traveller Rental Pune Nashik"],
    ["Weekend Trip Tempo Traveller Nashik", "Pune Nashik Travel Vehicle"],
    ["Nashik Darshan Tempo Traveller", "—"]
  ]
,


"whychoose": [
  {
    "WhyChooseheading": "Pune to Nashik Tempo Traveller on Rent with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable Pune to Nashik Tempo Traveller on rent services, ideal for family trips, group tours, corporate travel, and pilgrimage journeys."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Tempo Travellers",
    "WhyChoosedescription": "Travel from Pune to Nashik in spacious, air-conditioned, and well-maintained Tempo Travellers for a smooth and relaxing group journey."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Pune to Nashik Route",
    "WhyChoosedescription": "Our professional drivers are well-experienced with the Pune to Nashik route, ensuring safe, timely, and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides upfront pricing for Pune to Nashik Tempo Traveller rentals, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, travel queries, and trip coordination."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized Tempo Traveller rental plans for your Pune to Nashik journey."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All Tempo Travellers are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Pune to Nashik Tempo Traveller on rent."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide Pune to Nashik Tempo Traveller on rent?',
    answer: 'Yes, Sanavi Travels offers comfortable and well-maintained Tempo Travellers for Pune to Nashik travel.'
  },
  {
    question: 'How can I book a Pune to Nashik Tempo Traveller with Sanavi Travels?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What seating capacities are available for Pune to Nashik Tempo Traveller?',
    answer: 'We offer Tempo Travellers with different seating capacities suitable for small and large groups.'
  },
  {
    question: 'Are drivers included in the Tempo Traveller rental?',
    answer: 'Yes, all Tempo Traveller rentals include experienced and professional drivers.'
  },
  {
    question: 'Is the Pune to Nashik Tempo Traveller service available 24x7?',
    answer: 'Yes, our Pune to Nashik Tempo Traveller service is available round the clock.'
  },
  {
    question: 'Are the vehicles sanitized before the Pune to Nashik trip?',
    answer: 'Yes, all Tempo Travellers are thoroughly cleaned and sanitized before every journey.'
  },
  {
    question: 'Can I book a round-trip Tempo Traveller from Pune to Nashik?',
    answer: 'Absolutely. Sanavi Travels offers one-way and round-trip Tempo Traveller rental options.'
  },
  {
    question: 'What payment options are available for Pune to Nashik Tempo Traveller bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the Pune to Nashik journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ajay Kulkarni',
    feedback: 'Booked a Pune to Nashik Tempo Traveller with Sanavi Travels. Comfortable vehicle, smooth journey, and professional driver.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Rina Shah',
    feedback: 'Great experience with Sanavi Travels. Clean Tempo Traveller and on-time service made our Nashik trip enjoyable.',
    rating: 5
  }
];























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Nashik Tempo Traveller On Rent - Sanavi Travels",
  "description": "Pune to Nashik tempo traveller on rent by Sanavi Travels for wine tours, Nashik darshan, family trips, corporate travel, weekend getaways, and group journeys. Choose AC and luxury tempo travellers for a comfortable and affordable Pune to Nashik travel experience.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "3412"
  }
};






  return (
    <div>
<Helmet>
  <title>
    Pune to Nashik Tempo Traveller On Rent Starting from ₹31 Per Km | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book Pune to Nashik tempo traveller on rent with Sanavi Travels. AC and luxury tempo traveller for wine tours, Nashik darshan, family, corporate and group travel at affordable rates."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/7.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetonashiktempotravelleer;